/* eslint-disable react/require-default-props */
import React from 'react';
import { Space, Spin } from 'antd';
import { Container } from './style';

interface ILoading {
    title?: string;
    size?: 'small' | 'large' | 'default' | undefined;
}

const Loading: React.FC<ILoading> = ({ title, size }): JSX.Element => {
    return (
        <Container>
            <Space size="large">
                <Spin size={size} tip={title} />
            </Space>
        </Container>
    );
};
export default Loading;
